import React from 'react'
import { useNavigate } from 'react-router-dom'
import { BpButton } from '../../../shared/components/buttons/bp-button/BpButton'
import illustration from '../../../shared/assets/affiliate-tracking-stub-illustration.svg'
import { useCreateAffiliateRuleModal } from '../../../pages/project/widgets/affiliate-rule/useCreateAffiliateRuleModal'
import { StubContactLinks } from './StubContactLinks'

interface AffiliateTrackingStubProps {
  project?: string
  changeLocation?: boolean
}

export const AffiliateTrackingStub = ({
  project,
  changeLocation = false,
}: AffiliateTrackingStubProps) => {
  const navigate = useNavigate()
  const openCreateAffiliateRuleModal = useCreateAffiliateRuleModal()

  return (
    <div className={'flex justify-center'}>
      <div className={'flex w-full max-w-[440px] flex-col items-center gap-[24px]'}>
        <div className={'w-full'}>
          <img alt={'Illustration'} className={'max-w-full'} src={illustration} />
        </div>
        <div className={'flex w-full flex-col gap-[16px]'}>
          <div className={'flex flex-col items-center'}>
            <h2 className={'text-center text-[24px]'}>Set up affiliate tracking</h2>
            <p className={'max-w-[400px] text-center text-[15px] text-[#8E7CA7]'}>
              To start tracking non-compliant affiliates and networks add a tracking rule:
            </p>
          </div>
          <div
            className={'flex w-full flex-col gap-[16px] rounded-[16px] bg-focus/[0.06] p-[16px]'}
          >
            <p className={'flex items-center gap-[8px] text-focus-500'}>
              <span
                className={
                  'flex h-[24px] w-full max-w-[24px] items-center justify-center rounded-full bg-white text-[13px] text-[#8E7CA7] shadow-outline shadow-focus/[0.65]'
                }
              >
                1
              </span>
              Provide an example of an affiliate link
            </p>
            <p className={'flex items-center gap-[8px] text-focus-500'}>
              <span
                className={
                  'flex h-[24px] w-full max-w-[24px] items-center justify-center rounded-full bg-white text-[13px] text-[#8E7CA7] shadow-outline shadow-focus/[0.65]'
                }
              >
                2
              </span>
              Map the parameters and values needed to identify affiliates
            </p>
            <p className={'flex items-center gap-[8px] text-focus-500'}>
              <span
                className={
                  'flex h-[24px] w-full max-w-[24px] items-center justify-center rounded-full bg-white text-[13px] text-[#8E7CA7] shadow-outline shadow-focus/[0.65]'
                }
              >
                3
              </span>
              Review the tracking rule and hit CREATE!
            </p>
          </div>
          <div className={'flex justify-center'}>
            <BpButton
              className={'uppercase'}
              onClick={() => {
                changeLocation && navigate(`/projects/${project}/affiliate-tracking`)

                if (!project) return

                openCreateAffiliateRuleModal()
              }}
            >
              Set up tracking
            </BpButton>
          </div>
        </div>
        <div className={'flex flex-col gap-[8px]'}>
          <p className={'text-center text-[15px] text-[#8E7CA7]'}>Contact us for help</p>
          <StubContactLinks />
        </div>
      </div>
    </div>
  )
}
